import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('nav-bar',{attrs:{"show":_vm.showNav,"logout":_vm.logout},on:{"update:show":function($event){_vm.showNav=$event}}}),(_vm.$isMobile())?_c(VAppBar,{attrs:{"dense":"","app":""}},[_c(VAppBarNavIcon,{on:{"click":function($event){_vm.showNav = true}}})],1):_vm._e(),_c(VMain,{staticClass:"stretch",attrs:{"fill-height":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }